// oxlint-disable react/no-array-index-key -- index is the identity
import { styled } from "goober";

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 100%;
`;

const Element = styled("div")`
  border-radius: 2px;
  height: 100%;
`;

type Props = {
  colors: string[];
  width?: number;
};

export function Blob({ colors, width = 3 }: Props) {
  return (
    <Container>
      {colors.map((color, i) => (
        <Element
          key={`${i}-${color}`}
          style={{ width, backgroundColor: color }}
        />
      ))}
    </Container>
  );
}
